/** @file Constants for ATv2 settings. */
import moment from 'moment';
const KB = 1024;
const MB = KB * KB;
/**
 * The maximum compound size of all the files uploaded as part of an AutoTest
 * 2.0 configuration.
 */
export const MAX_STORAGE_SIZE = 10 * MB;
/** The maximum size of a single file part of an AutoTest 2.0 configuration. */
export const MAX_FILE_SIZE = 1 * MB;
/**
 * The maximum size of a single update (CRDT) to a file in dynamodb. This is
 * not the same as `MAX_DYNAMO_FILE_SIZE`, as it refers to a single edit
 * operation. This limit is to avoid having huge items stored in dynamodb, as
 * storage is expensive. If the CRDT exceeds the given size, it will be uploaded
 * to a S3 object.
 */
export const MAX_INLINE_CRDT_SIZE = 20 * KB;
/** The maximum size of uploaded files from Output step. */
export const MAX_OUTPUT_FILES_SIZE = 10 * MB;
/** The maximum size of output files on structured output. */
export const MAX_FILE_OUTPUTS = 15;
/** The maximum size of a single output file on structured output. */
export const MAX_FILE_OUTPUT_SIZE = 2 * MB;
/**
 * The max output a command from a build step is allowed to output before
 * output is truncated.
 */
export const BUILD_OUTPUT_LIMIT = 256 * KB;
/**
 * The max output a command from a test step is allowed to output before output
 * is truncated.
 */
export const TEST_OUTPUT_LIMIT = 128 * KB;
/** The maximum duration of a command in the Setup phase. */
export const BUILD_MAX_COMMAND_TIME = moment.duration(30, 'minutes');
/** The maximum duration of a command in the Test phase. */
export const TEST_MAX_COMMAND_TIME = moment.duration(2, 'minutes');
/**
 * The maximum age a submission can be before we do not retry subscribing to
 * its result if it cannot be found the first time.
 */
export const OLD_SUBMISSION_AGE = moment.duration(5, 'minutes');
/**
 * How many lines of output we will still animate using the collapseable body
 * in ATv2 output viewer.
 */
export const ANIMATION_LIMIT_LINES_COUNT = 100;
/**
 * How many steps in the failed state to expand automatically. Set to
 * a negative value to automatically expand all steps.
 */
export const AUTO_EXPAND_FAILED_STEPS = 1;
/**
 * The amount of time that the step will run before its output will
 * automatically uncollapse in the output viewer unless the user has toggled
 * the collapse themselves.
 */
export const UNCOLLAPSING_STEP_OUTPUT_DELAY = moment.duration(2, 'seconds');
